var app = angular.module('directives.cvvKeyboard');

app.directive('cvvKeyboard', ['PortalApi', 'Notification',  '$compile',
    function(PortalApi, Notification, $compile) {
        return {

            restrict: 'E',
            scope:{
                secure: '=',
                show:'='
            },
            template: require('../templates/cvv.html'),
            link: postLink
        };

        function postLink($scope, el, attrs, controller) {
            $scope.secure = '';

            function init() {
              $scope.numbers = [0,1,2,3,4,5,6,7,8,9];
              Array.prototype.shuffle = function() {
                  var input = this;                     
                  for (var i = input.length-1; i >=0; i--) {                     
                      var randomIndex = Math.floor(Math.random()*(i+1));
                      var itemAtIndex = input[randomIndex];                         
                      input[randomIndex] = input[i];
                      input[i] = itemAtIndex;
                  }
                  return input;
              }
              $scope.numbers.shuffle();
              $scope.numbers.push('check');
              $scope.numbers.splice(9, 0, 'clear');
            }

            $scope.select = function(n){

                if ($scope.secure.length == 3) {
                    return;
                }

                $scope.secure =  $scope.secure + n.toString();

            };

            $scope.clear = function () {
                $scope.secure = '';
            };

            $scope.close = function () {
                init();
                $scope.show = false;
            };

            init();
        }

    }
]);

module.exports = 'directives.cvvKeyboard';



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/cvvKeyboard/directives/cvv.js
 ** module id = 158
 ** module chunks = 1
 **/